import { PositionScenarios } from "../../types";

export const lplScenarios: PositionScenarios = {
  "1": {
    "1": [
      { "7": 0, "9": 1, "11": 0, "12": 1 },
      { "7": 1, "10": 0, "11": 1, "12": 1 },
      { "7": 0, "9": 0, "12": 0 },
    ],
    "2": [
      { "8": 0, "9": 0, "11": 0, "12": 1 },
      { "8": 1, "10": 1, "11": 1, "12": 1 },
      { "8": 0, "9": 1, "12": 0 },
    ],
    "3": [
      { "6": 0, "8": 1, "9": 0, "11": 0, "12": 1 },
      { "6": 0, "8": 0, "10": 1, "11": 1, "12": 1 },
      { "6": 0, "8": 1, "9": 1, "12": 0 },
    ],
    "4": [
      { "5": 0, "7": 1, "9": 1, "11": 0, "12": 1 },
      { "5": 0, "7": 0, "10": 0, "11": 1, "12": 1 },
      { "5": 0, "7": 1, "9": 0, "12": 0 },
    ],
    "5": [
      { "3": 0, "5": 1, "7": 1, "9": 1, "11": 0, "12": 1 },
      { "3": 0, "5": 1, "7": 0, "10": 0, "11": 1, "12": 1 },
      { "3": 0, "5": 1, "7": 1, "9": 0, "12": 0 },
    ],
    "6": [
      { "4": 0, "6": 1, "8": 1, "9": 0, "11": 0, "12": 1 },
      { "4": 0, "6": 1, "8": 0, "10": 1, "11": 1, "12": 1 },
      { "4": 0, "6": 1, "8": 1, "9": 1, "12": 0 },
    ],
    "7": [
      { "2": 0, "4": 1, "6": 1, "8": 1, "9": 0, "11": 0, "12": 1 },
      { "2": 0, "4": 1, "6": 1, "8": 0, "10": 1, "11": 1, "12": 1 },
      { "2": 0, "4": 1, "6": 1, "8": 1, "9": 1, "12": 0 },
    ],
    "8": [
      { "1": 1, "3": 1, "5": 1, "7": 1, "9": 1, "11": 0, "12": 1 },
      { "1": 1, "3": 1, "5": 1, "7": 0, "10": 0, "11": 1, "12": 1 },
      { "1": 1, "3": 1, "5": 1, "7": 1, "9": 0, "12": 0 },
    ],
    "9": [
      { "1": 0, "3": 1, "5": 1, "7": 1, "9": 1, "11": 0, "12": 1 },
      { "1": 0, "3": 1, "5": 1, "7": 0, "10": 0, "11": 1, "12": 1 },
      { "1": 0, "3": 1, "5": 1, "7": 1, "9": 0, "12": 0 },
    ],
    "10": [
      { "2": 1, "4": 1, "6": 1, "8": 1, "9": 0, "11": 0, "12": 1 },
      { "2": 1, "4": 1, "6": 1, "8": 0, "10": 1, "11": 1, "12": 1 },
      { "2": 1, "4": 1, "6": 1, "8": 1, "9": 1, "12": 0 },
    ],
  },
  "2": {
    "1": [
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "3": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "3": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "3": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "12": 0,
      },
      {
        "1": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      { "1": 0, "3": 0, "4": 1, "5": 0, "6": 1, "8": 0, "9": 1, "12": 0 },
      { "1": 1, "3": 1, "4": 0, "5": 0, "7": 0, "8": 0, "9": 1, "12": 0 },
      { "1": 0, "3": 1, "4": 1, "6": 0, "7": 0, "8": 0, "9": 1, "12": 0 },
      { "1": 1, "3": 0, "4": 0, "7": 1, "8": 0, "9": 1, "10": 0, "12": 0 },
      { "1": 1, "3": 1, "5": 0, "7": 0, "8": 1, "9": 1, "10": 0, "11": 1 },
      { "1": 1, "3": 1, "5": 1, "7": 0, "8": 0, "9": 1, "10": 1, "12": 0 },
      { "1": 1, "3": 1, "5": 1, "7": 1, "8": 1, "9": 0, "10": 0, "12": 0 },
      { "1": 0, "3": 0, "5": 0, "7": 1, "8": 0, "9": 0, "11": 0, "12": 1 },
      { "1": 1, "3": 1, "5": 1, "7": 0, "8": 1, "9": 1, "11": 1, "12": 1 },
      { "1": 1, "3": 1, "5": 0, "7": 1, "8": 1, "10": 0, "11": 1, "12": 0 },
      { "1": 1, "3": 1, "5": 1, "7": 1, "8": 0, "10": 0, "11": 1, "12": 0 },
      { "1": 0, "3": 1, "7": 0, "8": 1, "9": 1, "10": 1, "11": 1, "12": 1 },
      { "1": 1, "3": 0, "7": 1, "8": 0, "9": 0, "10": 0, "11": 1, "12": 0 },
      { "1": 1, "4": 1, "5": 0, "6": 0, "7": 0, "8": 0, "9": 1, "12": 0 },
      { "3": 0, "4": 1, "5": 1, "7": 1, "8": 0, "9": 1, "10": 0, "12": 0 },
      { "3": 0, "4": 0, "7": 0, "8": 1, "9": 1, "10": 1, "11": 1, "12": 1 },
      { "3": 0, "5": 1, "7": 1, "8": 0, "9": 0, "10": 0, "11": 0, "12": 1 },
      { "1": 0, "3": 1, "4": 1, "6": 1, "8": 0, "9": 1, "12": 0 },
      { "1": 1, "3": 0, "4": 0, "7": 0, "8": 0, "9": 1, "12": 0 },
      { "1": 1, "3": 1, "5": 0, "7": 1, "8": 1, "10": 0, "11": 0 },
      { "1": 1, "3": 0, "7": 0, "8": 1, "9": 1, "10": 0, "11": 1 },
      { "1": 0, "3": 1, "7": 1, "8": 0, "9": 0, "11": 0, "12": 1 },
      { "1": 1, "3": 0, "7": 1, "8": 1, "10": 0, "11": 1, "12": 0 },
      { "1": 1, "4": 1, "5": 0, "6": 1, "8": 0, "9": 1, "12": 0 },
      { "1": 0, "4": 0, "7": 1, "8": 0, "9": 1, "10": 0, "12": 0 },
      { "1": 1, "5": 0, "7": 1, "8": 0, "9": 0, "11": 0, "12": 1 },
      { "1": 0, "7": 1, "8": 0, "9": 0, "10": 0, "11": 1, "12": 0 },
      { "3": 0, "4": 1, "5": 1, "7": 0, "8": 0, "9": 1, "12": 0 },
      { "1": 1, "3": 0, "7": 1, "8": 1, "10": 0, "11": 0 },
      { "1": 0, "4": 0, "7": 0, "8": 0, "9": 1, "12": 0 },
      { "1": 0, "7": 0, "8": 1, "9": 1, "10": 0, "11": 1 },
      { "1": 0, "7": 1, "8": 1, "10": 0, "11": 1, "12": 0 },
      { "1": 0, "7": 1, "8": 1, "10": 0, "11": 0 },
      { "7": 0, "8": 1, "9": 1, "11": 0, "12": 0 },
      { "7": 0, "9": 0, "12": 1 },
    ],
    "2": [
      {
        "1": 1,
        "3": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      { "1": 1, "3": 1, "5": 1, "7": 0, "8": 1, "9": 0, "10": 1, "12": 0 },
      { "1": 1, "3": 1, "5": 0, "7": 1, "8": 1, "10": 0, "11": 1, "12": 1 },
      { "1": 1, "3": 1, "5": 1, "7": 0, "8": 0, "9": 0, "12": 0 },
      { "1": 1, "3": 0, "7": 1, "8": 1, "10": 0, "11": 1, "12": 1 },
      { "1": 1, "3": 1, "5": 0, "7": 0, "9": 0, "12": 0 },
      { "1": 0, "7": 1, "8": 1, "10": 0, "11": 1, "12": 1 },
      { "7": 0, "8": 1, "9": 1, "10": 1, "11": 1, "12": 0 },
      { "7": 1, "8": 0, "9": 0, "10": 0, "11": 1, "12": 1 },
      { "1": 1, "3": 0, "7": 0, "9": 0, "12": 0 },
      { "7": 1, "8": 0, "9": 0, "10": 1, "11": 1 },
      { "7": 0, "8": 1, "9": 1, "11": 0, "12": 1 },
      { "7": 1, "8": 0, "9": 0, "11": 0, "12": 0 },
      { "7": 1, "8": 1, "10": 1, "11": 1, "12": 0 },
      { "1": 0, "7": 0, "9": 0, "12": 0 },
      { "7": 1, "8": 1, "10": 1, "11": 0 },
      { "8": 0, "9": 1, "12": 1 },
    ],
    "3": [
      { "6": 0, "7": 1, "8": 0, "9": 1, "10": 1, "11": 1, "12": 0 },
      { "6": 0, "7": 1, "8": 1, "9": 1, "10": 1, "11": 1, "12": 1 },
    ],
    "4": [],
    "5": [
      { "3": 0, "5": 1, "7": 1, "8": 0, "9": 0, "10": 1, "11": 0, "12": 1 },
      { "3": 0, "5": 1, "7": 1, "8": 0, "9": 1, "10": 1, "11": 0, "12": 0 },
      { "3": 0, "5": 1, "7": 1, "8": 1, "9": 0, "10": 1, "11": 1, "12": 1 },
    ],
    "6": [
      { "4": 0, "6": 1, "7": 1, "8": 0, "9": 1, "10": 1, "11": 1, "12": 0 },
      { "4": 0, "6": 1, "7": 1, "8": 1, "9": 1, "10": 1, "11": 1, "12": 1 },
    ],
    "7": [],
    "8": [
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      { "1": 1, "3": 1, "5": 1, "7": 1, "8": 1, "9": 0, "10": 0, "12": 1 },
      { "1": 1, "3": 1, "5": 1, "7": 1, "8": 0, "9": 0, "11": 0, "12": 1 },
      { "1": 1, "3": 1, "5": 1, "7": 0, "8": 1, "10": 0, "11": 1, "12": 0 },
    ],
    "9": [],
    "10": [],
  },
  "3": {
    "1": [
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "3": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "3": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "12": 1,
      },
      {
        "1": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      { "1": 0, "3": 0, "4": 0, "5": 0, "7": 1, "9": 1, "10": 1, "11": 1 },
      { "1": 0, "3": 1, "4": 1, "6": 1, "7": 1, "8": 1, "10": 1, "11": 0 },
      { "1": 0, "3": 1, "4": 1, "6": 0, "7": 1, "9": 1, "10": 1, "11": 1 },
      { "1": 0, "3": 1, "4": 0, "7": 1, "8": 0, "9": 1, "11": 0, "12": 1 },
      { "1": 1, "3": 1, "5": 1, "7": 0, "8": 0, "9": 1, "10": 0, "11": 1 },
      { "1": 1, "3": 1, "5": 1, "7": 1, "8": 1, "9": 0, "10": 1, "11": 1 },
      { "1": 0, "3": 0, "5": 0, "7": 1, "8": 0, "9": 0, "11": 0, "12": 0 },
      { "1": 1, "3": 1, "5": 0, "7": 0, "8": 0, "9": 1, "11": 1, "12": 1 },
      { "1": 1, "3": 1, "5": 1, "7": 0, "8": 1, "9": 1, "11": 1, "12": 0 },
      { "1": 0, "3": 1, "7": 0, "8": 1, "9": 1, "10": 1, "11": 1, "12": 0 },
      { "1": 1, "4": 1, "5": 0, "6": 1, "7": 1, "8": 1, "10": 1, "11": 0 },
      { "1": 1, "4": 1, "5": 0, "6": 0, "7": 1, "9": 1, "10": 1, "11": 1 },
      { "1": 1, "4": 0, "5": 0, "7": 1, "8": 0, "9": 1, "11": 0, "12": 1 },
      { "3": 0, "4": 1, "5": 1, "6": 0, "7": 1, "8": 0, "9": 1, "10": 1 },
      { "3": 0, "4": 1, "5": 1, "6": 0, "7": 1, "8": 1, "10": 1, "11": 1 },
      { "3": 0, "4": 1, "5": 1, "6": 1, "7": 1, "8": 0, "10": 1, "11": 0 },
      { "3": 0, "4": 0, "5": 1, "7": 1, "8": 0, "9": 0, "10": 1, "11": 0 },
      { "3": 0, "4": 0, "7": 0, "8": 1, "9": 1, "10": 1, "11": 1, "12": 0 },
      { "3": 0, "5": 1, "7": 1, "8": 0, "9": 0, "10": 0, "11": 0, "12": 0 },
      { "3": 0, "5": 1, "7": 1, "8": 0, "9": 1, "10": 0, "11": 0, "12": 1 },
      { "1": 0, "3": 1, "4": 0, "7": 1, "9": 1, "10": 1, "11": 1 },
      { "1": 0, "3": 1, "7": 1, "8": 0, "9": 0, "11": 0, "12": 0 },
      { "1": 1, "3": 0, "7": 0, "8": 0, "9": 1, "11": 1, "12": 1 },
      { "1": 1, "4": 0, "5": 0, "7": 1, "9": 1, "10": 1, "11": 1 },
      { "1": 1, "5": 0, "7": 1, "8": 0, "9": 0, "11": 0, "12": 0 },
      { "3": 0, "4": 0, "5": 1, "7": 1, "8": 0, "9": 1, "10": 1 },
      { "3": 0, "4": 0, "5": 1, "7": 1, "8": 1, "10": 1, "11": 1 },
      { "1": 1, "3": 1, "5": 1, "7": 1, "8": 0, "11": 0 },
      { "1": 0, "7": 0, "8": 0, "9": 1, "11": 1, "12": 1 },
    ],
    "2": [
      {
        "1": 1,
        "3": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "3": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "3": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "3": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      { "1": 1, "3": 1, "5": 0, "7": 0, "8": 1, "9": 1, "10": 0, "11": 1 },
      { "1": 1, "3": 1, "5": 0, "7": 0, "8": 1, "9": 0, "10": 0, "12": 1 },
      { "1": 1, "3": 1, "5": 1, "7": 0, "8": 1, "9": 0, "11": 0, "12": 1 },
      { "1": 1, "3": 1, "5": 0, "7": 1, "8": 1, "10": 0, "11": 1, "12": 0 },
      { "1": 1, "3": 0, "7": 0, "8": 1, "9": 0, "10": 1, "11": 0, "12": 1 },
      { "1": 1, "3": 1, "5": 0, "7": 1, "8": 1, "10": 0, "11": 0 },
      { "1": 1, "3": 1, "5": 1, "8": 1, "9": 0, "10": 0, "11": 1 },
      { "1": 1, "3": 0, "7": 0, "8": 1, "9": 1, "10": 0, "11": 1 },
      { "1": 1, "3": 0, "7": 0, "8": 1, "9": 0, "10": 0, "12": 1 },
      { "1": 1, "3": 0, "7": 1, "8": 1, "10": 0, "11": 1, "12": 0 },
      { "1": 0, "7": 0, "8": 1, "9": 0, "10": 1, "11": 0, "12": 1 },
      { "1": 1, "3": 0, "7": 1, "8": 1, "10": 0, "11": 0 },
      { "1": 0, "7": 0, "8": 1, "9": 1, "10": 0, "11": 1 },
      { "1": 0, "7": 0, "8": 1, "9": 0, "10": 0, "12": 1 },
      { "1": 0, "7": 1, "8": 1, "10": 0, "11": 1, "12": 0 },
      { "7": 1, "8": 0, "9": 0, "10": 0, "11": 1, "12": 0 },
      { "1": 0, "7": 1, "8": 1, "10": 0, "11": 0 },
      { "7": 0, "8": 0, "9": 0, "11": 1, "12": 1 },
      { "7": 0, "8": 1, "9": 1, "11": 0, "12": 0 },
    ],
    "3": [
      {
        "1": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      { "1": 1, "3": 1, "5": 0, "6": 0, "7": 0, "8": 0, "10": 1, "11": 0 },
      { "1": 1, "3": 0, "6": 0, "7": 0, "8": 1, "9": 0, "10": 1, "11": 1 },
      { "1": 1, "3": 0, "6": 0, "7": 0, "8": 0, "10": 1, "11": 0 },
      { "1": 0, "6": 0, "7": 0, "8": 1, "9": 0, "10": 1, "11": 1 },
      { "6": 0, "7": 0, "8": 1, "9": 1, "10": 0, "11": 0, "12": 1 },
      { "6": 0, "7": 1, "8": 0, "9": 0, "10": 1, "11": 1, "12": 0 },
      { "6": 0, "7": 1, "8": 1, "9": 0, "10": 1, "11": 0, "12": 0 },
      { "6": 0, "7": 1, "8": 1, "9": 1, "10": 0, "11": 1, "12": 1 },
      { "6": 0, "7": 1, "8": 1, "9": 1, "10": 1, "11": 0, "12": 1 },
      { "1": 0, "6": 0, "7": 0, "8": 0, "10": 1, "11": 0 },
      { "6": 0, "7": 0, "8": 1, "9": 1, "10": 1, "12": 1 },
      { "6": 0, "7": 0, "8": 1, "9": 0, "11": 0, "12": 0 },
      { "6": 0, "7": 0, "8": 0, "10": 1, "11": 1, "12": 0 },
    ],
    "4": [
      { "5": 0, "7": 0, "8": 1, "9": 0, "10": 0, "11": 1, "12": 0 },
      { "5": 0, "7": 1, "8": 0, "9": 0, "10": 1, "11": 0, "12": 1 },
      { "5": 0, "7": 1, "8": 0, "9": 1, "10": 0, "11": 1 },
      { "5": 0, "7": 1, "8": 0, "9": 0, "10": 0, "12": 1 },
      { "5": 0, "7": 1, "8": 0, "9": 1, "11": 0, "12": 0 },
      { "5": 0, "7": 1, "8": 1, "9": 0, "11": 1, "12": 1 },
      { "5": 0, "7": 0, "8": 0, "10": 0, "11": 1, "12": 0 },
      { "5": 0, "7": 0, "8": 0, "10": 0, "11": 0 },
    ],
    "5": [
      {
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "10": 0,
        "11": 0,
      },
      { "2": 1, "3": 0, "4": 1, "5": 1, "6": 1, "7": 0, "8": 0, "11": 0 },
      { "2": 1, "3": 0, "4": 0, "5": 1, "7": 0, "8": 0, "10": 0, "11": 0 },
      { "3": 0, "5": 1, "7": 0, "8": 1, "9": 0, "10": 0, "11": 1, "12": 0 },
      { "3": 0, "5": 1, "7": 1, "8": 0, "9": 0, "10": 1, "11": 1, "12": 1 },
      { "3": 0, "5": 1, "7": 1, "8": 0, "9": 1, "10": 0, "11": 0, "12": 0 },
      { "3": 0, "5": 1, "7": 1, "8": 1, "9": 0, "10": 0, "11": 1, "12": 1 },
      { "3": 0, "5": 1, "7": 1, "8": 1, "9": 0, "10": 1, "11": 0, "12": 1 },
      { "3": 0, "5": 1, "7": 1, "8": 1, "9": 1, "10": 1, "11": 0, "12": 0 },
      { "2": 0, "3": 0, "5": 1, "7": 0, "8": 0, "10": 0, "11": 0 },
      { "3": 0, "5": 1, "7": 1, "8": 0, "9": 1, "10": 0, "11": 1 },
      { "3": 0, "5": 1, "7": 1, "8": 0, "9": 0, "10": 0, "12": 1 },
      { "3": 0, "5": 1, "7": 0, "8": 0, "10": 0, "11": 1, "12": 0 },
    ],
    "6": [
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      { "1": 1, "3": 0, "4": 0, "6": 1, "7": 0, "8": 0, "10": 1, "11": 0 },
      { "1": 0, "4": 0, "6": 1, "7": 0, "8": 1, "9": 0, "10": 1, "11": 1 },
      { "4": 0, "6": 1, "7": 0, "8": 1, "9": 1, "10": 0, "11": 0, "12": 1 },
      { "4": 0, "6": 1, "7": 1, "8": 0, "9": 0, "10": 1, "11": 1, "12": 0 },
      { "4": 0, "6": 1, "7": 1, "8": 1, "9": 0, "10": 1, "11": 0, "12": 0 },
      { "4": 0, "6": 1, "7": 1, "8": 1, "9": 1, "10": 0, "11": 1, "12": 1 },
      { "4": 0, "6": 1, "7": 1, "8": 1, "9": 1, "10": 1, "11": 0, "12": 1 },
      { "1": 0, "4": 0, "6": 1, "7": 0, "8": 0, "10": 1, "11": 0 },
      { "4": 0, "6": 1, "7": 0, "8": 1, "9": 1, "10": 1, "12": 1 },
      { "4": 0, "6": 1, "7": 0, "8": 1, "9": 0, "11": 0, "12": 0 },
      { "4": 0, "6": 1, "7": 0, "8": 0, "10": 1, "11": 1, "12": 0 },
    ],
    "7": [
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      { "1": 0, "2": 0, "4": 1, "6": 1, "7": 0, "8": 0, "10": 1, "11": 0 },
      { "2": 0, "4": 1, "6": 1, "7": 0, "8": 1, "9": 1, "10": 1, "12": 1 },
      { "2": 0, "4": 1, "6": 1, "7": 0, "8": 0, "10": 1, "11": 1, "12": 0 },
    ],
    "8": [
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "3": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      { "1": 1, "3": 1, "4": 0, "5": 1, "7": 1, "8": 0, "9": 1, "11": 1 },
      { "1": 1, "3": 1, "5": 1, "7": 0, "8": 1, "9": 0, "10": 1, "11": 1 },
      { "1": 1, "3": 1, "5": 1, "7": 1, "8": 0, "9": 0, "11": 1, "12": 1 },
      { "1": 1, "3": 1, "5": 1, "7": 0, "8": 0, "11": 0 },
    ],
    "9": [
      {
        "1": 0,
        "3": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "3": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      { "1": 0, "3": 1, "5": 1, "7": 1, "8": 0, "9": 1, "10": 0, "11": 1 },
      { "1": 0, "3": 1, "5": 1, "7": 1, "8": 0, "9": 0, "10": 0, "12": 1 },
      { "1": 0, "3": 1, "5": 1, "7": 1, "8": 0, "9": 1, "11": 0, "12": 0 },
      { "1": 0, "3": 1, "5": 1, "7": 1, "8": 1, "9": 0, "11": 1, "12": 1 },
      { "1": 0, "3": 1, "5": 1, "7": 0, "8": 0, "10": 0, "11": 1, "12": 0 },
      { "1": 0, "3": 1, "5": 1, "7": 0, "8": 0, "10": 0, "11": 0 },
    ],
    "10": [
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
      },
      { "2": 1, "4": 1, "6": 1, "7": 0, "8": 1, "9": 1, "10": 1, "12": 1 },
      { "2": 1, "4": 1, "6": 1, "7": 0, "8": 0, "10": 1, "11": 1, "12": 0 },
    ],
  },
  "4": {
    "1": [
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      { "1": 1, "3": 1, "4": 0, "5": 1, "7": 1, "8": 1, "9": 1, "10": 1 },
      { "1": 1, "3": 1, "4": 0, "5": 1, "7": 1, "8": 0, "10": 1, "11": 1 },
      { "3": 0, "4": 1, "5": 1, "6": 0, "7": 1, "8": 1, "10": 1, "11": 0 },
      { "3": 0, "4": 0, "5": 1, "7": 1, "8": 0, "9": 0, "10": 1, "11": 1 },
      { "3": 0, "4": 0, "5": 1, "7": 1, "8": 1, "10": 1, "11": 0 },
    ],
    "2": [
      {
        "1": 1,
        "3": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "3": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
    ],
    "3": [
      {
        "1": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      { "1": 1, "3": 1, "5": 0, "6": 0, "7": 1, "8": 1, "9": 0, "11": 1 },
      { "1": 1, "3": 1, "5": 0, "6": 0, "7": 1, "8": 0, "10": 1, "11": 0 },
      { "1": 1, "3": 0, "6": 0, "7": 0, "8": 1, "9": 0, "10": 0, "11": 1 },
      { "1": 1, "3": 1, "5": 1, "6": 0, "8": 1, "9": 0, "11": 1 },
      { "1": 1, "3": 1, "5": 1, "6": 0, "8": 0, "10": 1, "11": 0 },
      { "1": 1, "3": 0, "6": 0, "7": 1, "8": 1, "9": 0, "11": 1 },
      { "1": 1, "3": 0, "6": 0, "7": 1, "8": 0, "10": 1, "11": 0 },
      { "1": 0, "6": 0, "7": 0, "8": 1, "9": 0, "10": 0, "11": 1 },
      { "6": 0, "7": 0, "8": 1, "9": 1, "10": 0, "11": 1, "12": 1 },
      { "6": 0, "7": 1, "8": 1, "9": 0, "10": 0, "11": 0, "12": 0 },
      { "6": 0, "7": 1, "8": 1, "9": 1, "10": 0, "11": 0, "12": 1 },
      { "1": 1, "3": 1, "5": 1, "6": 0, "8": 0, "10": 0 },
      { "1": 0, "6": 0, "7": 1, "8": 1, "9": 0, "11": 1 },
      { "1": 0, "6": 0, "7": 1, "8": 0, "10": 1, "11": 0 },
      { "1": 1, "3": 0, "6": 0, "8": 0, "10": 0 },
      { "1": 0, "6": 0, "8": 0, "10": 0 },
    ],
    "4": [
      { "5": 0, "7": 0, "8": 1, "9": 1, "10": 0, "11": 1, "12": 0 },
      { "5": 0, "7": 1, "8": 0, "9": 0, "10": 1, "11": 1, "12": 1 },
      { "5": 0, "7": 1, "8": 0, "9": 1, "10": 1, "11": 1 },
      { "5": 0, "7": 1, "8": 1, "9": 0, "11": 0, "12": 1 },
      { "5": 0, "7": 1, "8": 1, "9": 1, "11": 0, "12": 0 },
      { "1": 1, "3": 0, "5": 0, "7": 0, "10": 1 },
      { "5": 0, "7": 1, "8": 1, "9": 1, "11": 1 },
      { "5": 0, "7": 0, "8": 1, "10": 0, "11": 0 },
      { "1": 0, "5": 0, "7": 0, "10": 1 },
    ],
    "5": [
      {
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
      },
      {
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
      },
      {
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
        "11": 0,
      },
      {
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
      },
      { "2": 1, "3": 0, "4": 0, "5": 1, "7": 0, "8": 1, "10": 0, "11": 0 },
      { "3": 0, "5": 1, "7": 0, "8": 1, "9": 1, "10": 0, "11": 1, "12": 0 },
      { "3": 0, "5": 1, "7": 1, "8": 1, "9": 0, "10": 0, "11": 0, "12": 1 },
      { "3": 0, "5": 1, "7": 1, "8": 1, "9": 1, "10": 0, "11": 0, "12": 0 },
      { "2": 1, "3": 0, "4": 1, "5": 1, "6": 0, "7": 0, "10": 1 },
      { "2": 1, "3": 0, "4": 1, "5": 0, "6": 1, "8": 0, "10": 0 },
      { "2": 0, "3": 0, "5": 1, "7": 0, "8": 1, "10": 0, "11": 0 },
      { "3": 0, "5": 1, "7": 1, "8": 0, "9": 1, "10": 1, "11": 1 },
      { "2": 1, "3": 0, "4": 0, "5": 1, "7": 0, "10": 1 },
      { "3": 0, "5": 1, "7": 1, "8": 1, "9": 1, "11": 1 },
      { "2": 0, "3": 0, "5": 1, "7": 0, "10": 1 },
    ],
    "6": [
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      { "1": 1, "3": 1, "4": 0, "5": 1, "6": 1, "8": 1, "9": 0, "11": 1 },
      { "1": 1, "3": 1, "4": 0, "5": 1, "6": 1, "8": 0, "10": 1, "11": 0 },
      { "1": 1, "3": 0, "4": 0, "6": 1, "7": 1, "8": 1, "9": 0, "11": 1 },
      { "1": 1, "3": 0, "4": 0, "6": 1, "7": 1, "8": 0, "10": 1, "11": 0 },
      { "1": 0, "4": 0, "6": 1, "7": 0, "8": 1, "9": 0, "10": 0, "11": 1 },
      { "4": 0, "6": 1, "7": 0, "8": 1, "9": 1, "10": 0, "11": 1, "12": 1 },
      { "4": 0, "6": 1, "7": 1, "8": 1, "9": 0, "10": 0, "11": 0, "12": 0 },
      { "4": 0, "6": 1, "7": 1, "8": 1, "9": 1, "10": 0, "11": 0, "12": 1 },
      { "1": 1, "3": 1, "4": 0, "5": 1, "6": 1, "8": 0, "10": 0 },
      { "1": 0, "4": 0, "6": 1, "7": 1, "8": 1, "9": 0, "11": 1 },
      { "1": 0, "4": 0, "6": 1, "7": 1, "8": 0, "10": 1, "11": 0 },
      { "1": 1, "3": 0, "4": 0, "6": 1, "8": 0, "10": 0 },
      { "1": 0, "4": 0, "6": 1, "8": 0, "10": 0 },
    ],
    "7": [
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "8": 1,
        "9": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "8": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      { "1": 1, "2": 0, "3": 1, "4": 1, "5": 1, "6": 1, "8": 0, "10": 0 },
      { "1": 0, "2": 0, "4": 1, "6": 1, "7": 1, "8": 1, "9": 0, "11": 1 },
      { "1": 0, "2": 0, "4": 1, "6": 1, "7": 1, "8": 0, "10": 1, "11": 0 },
      { "2": 0, "4": 1, "6": 1, "7": 1, "8": 1, "9": 0, "11": 0, "12": 0 },
      { "1": 1, "2": 0, "3": 0, "4": 1, "6": 1, "8": 0, "10": 0 },
      { "1": 0, "2": 0, "4": 1, "6": 1, "8": 0, "10": 0 },
    ],
    "8": [
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      { "1": 1, "2": 1, "3": 1, "4": 1, "5": 0, "6": 0, "7": 0, "8": 0 },
      { "1": 1, "2": 1, "3": 1, "4": 1, "5": 0, "6": 1, "8": 0, "10": 0 },
      { "1": 1, "2": 1, "3": 1, "4": 0, "5": 0, "7": 0, "8": 1, "10": 1 },
      { "1": 1, "2": 1, "3": 1, "4": 0, "5": 0, "7": 1, "8": 0, "10": 0 },
      { "1": 1, "3": 1, "4": 0, "5": 1, "7": 0, "8": 1, "9": 0, "11": 0 },
      { "1": 1, "2": 1, "3": 1, "4": 0, "5": 0, "7": 0, "8": 0 },
      { "1": 1, "2": 0, "3": 1, "5": 0, "7": 0, "8": 1, "10": 1 },
      { "1": 1, "2": 0, "3": 1, "5": 0, "7": 1, "8": 0, "10": 0 },
      { "1": 1, "3": 1, "5": 1, "7": 0, "8": 1, "9": 1, "10": 1 },
      { "1": 1, "3": 1, "5": 1, "7": 0, "8": 0, "10": 1, "11": 1 },
      { "1": 1, "2": 0, "3": 1, "5": 0, "7": 0, "8": 0 },
    ],
    "9": [
      {
        "1": 0,
        "3": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "3": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      { "1": 0, "3": 1, "5": 1, "7": 1, "8": 0, "9": 1, "10": 1, "11": 1 },
      { "1": 0, "3": 1, "5": 1, "7": 1, "8": 1, "9": 0, "11": 0, "12": 1 },
      { "1": 0, "3": 1, "5": 1, "7": 1, "8": 1, "9": 1, "11": 0, "12": 0 },
      { "1": 0, "3": 1, "5": 1, "7": 1, "8": 1, "9": 1, "11": 1 },
      { "1": 0, "3": 1, "5": 1, "7": 0, "8": 1, "10": 0, "11": 0 },
      { "1": 0, "3": 1, "5": 1, "7": 0, "10": 1 },
    ],
    "10": [
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "8": 1,
        "9": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "8": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "4": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
      },
      {
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 1,
        "11": 0,
      },
      { "1": 0, "2": 1, "3": 0, "4": 1, "5": 1, "6": 1, "8": 0, "10": 0 },
      { "1": 1, "2": 1, "4": 1, "5": 1, "6": 1, "8": 1, "9": 0, "11": 1 },
      { "1": 1, "2": 1, "4": 1, "5": 1, "6": 1, "8": 0, "10": 1, "11": 0 },
      { "2": 1, "4": 1, "6": 1, "7": 1, "8": 1, "9": 0, "11": 0, "12": 0 },
      { "1": 0, "2": 1, "3": 1, "4": 1, "6": 1, "8": 0, "10": 0 },
      { "1": 1, "2": 1, "4": 1, "5": 1, "6": 1, "8": 0, "10": 0 },
    ],
  },
  "5": {
    "1": [],
    "2": [],
    "3": [
      { "1": 1, "3": 1, "5": 0, "6": 0, "8": 0, "10": 0 },
      { "1": 0, "3": 0, "5": 1, "6": 1 },
      { "1": 0, "3": 1, "6": 1 },
      { "1": 1, "5": 1, "6": 1 },
    ],
    "4": [
      { "1": 1, "3": 1, "4": 1, "5": 1, "6": 0 },
      { "1": 1, "3": 1, "5": 0, "7": 0, "10": 1 },
      { "1": 0, "4": 1, "5": 1, "6": 0 },
    ],
    "5": [
      { "2": 1, "3": 0, "4": 1, "5": 0, "6": 1, "8": 0, "10": 1 },
      { "2": 1, "3": 0, "4": 1, "5": 0, "6": 1, "8": 1 },
      { "2": 1, "3": 0, "4": 1, "5": 0, "6": 0 },
      { "2": 1, "3": 0, "4": 0, "5": 0 },
      { "2": 0, "3": 0, "5": 0 },
    ],
    "6": [
      { "1": 1, "3": 1, "4": 0, "5": 0, "6": 1, "8": 0, "10": 0 },
      { "1": 0, "3": 0, "4": 0, "5": 1, "6": 0 },
      { "1": 0, "3": 1, "4": 0, "6": 0 },
      { "1": 1, "4": 0, "5": 1, "6": 0 },
    ],
    "7": [
      { "1": 1, "2": 0, "3": 1, "4": 1, "5": 0, "6": 1, "8": 0, "10": 0 },
      { "1": 0, "2": 0, "3": 1, "4": 1, "5": 0, "6": 0 },
    ],
    "8": [
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "10": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "10": 1,
      },
      { "1": 1, "2": 1, "3": 1, "4": 1, "5": 0, "6": 0, "7": 1, "8": 1 },
      { "1": 1, "2": 1, "3": 1, "4": 0, "5": 0, "7": 0, "8": 1, "10": 0 },
      { "1": 1, "2": 1, "3": 1, "4": 0, "5": 0, "7": 1, "8": 0, "10": 1 },
      { "1": 1, "2": 1, "3": 1, "4": 0, "5": 0, "7": 1, "8": 1 },
      { "1": 1, "2": 0, "3": 1, "5": 0, "7": 0, "8": 1, "10": 0 },
      { "1": 1, "2": 0, "3": 1, "5": 0, "7": 1, "8": 0, "10": 1 },
      { "1": 0, "2": 1, "3": 1, "4": 1, "5": 0, "6": 0 },
      { "1": 1, "2": 0, "3": 1, "5": 0, "7": 1, "8": 1 },
      { "1": 1, "3": 0, "4": 1, "5": 1, "6": 0 },
    ],
    "9": [],
    "10": [
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "10": 1,
        "11": 0,
      },
      { "1": 0, "2": 1, "3": 0, "4": 1, "5": 0, "6": 1, "8": 0, "10": 0 },
      { "1": 1, "2": 1, "4": 1, "5": 0, "6": 1, "8": 0, "10": 0 },
    ],
  },
  "6": {
    "1": [],
    "2": [],
    "3": [
      { "1": 0, "3": 0, "5": 0, "6": 1 },
      { "1": 1, "5": 0, "6": 1 },
    ],
    "4": [
      { "1": 1, "3": 0, "4": 1, "5": 1, "6": 0 },
      { "1": 1, "3": 1, "4": 1, "5": 1, "6": 1 },
      { "1": 1, "3": 1, "4": 0, "5": 1 },
      { "1": 0, "4": 1, "5": 1, "6": 1 },
      { "1": 0, "4": 0, "5": 1 },
    ],
    "5": [],
    "6": [
      { "1": 0, "3": 0, "4": 0, "5": 0, "6": 0 },
      { "1": 1, "4": 0, "5": 0, "6": 0 },
    ],
    "7": [
      { "1": 0, "2": 0, "3": 1, "4": 1, "5": 1, "6": 0 },
      { "1": 0, "2": 0, "3": 0, "4": 1, "6": 0 },
      { "1": 1, "2": 0, "3": 1, "4": 1, "6": 0 },
    ],
    "8": [
      { "1": 0, "2": 1, "3": 1, "4": 1, "5": 0, "6": 1 },
      { "1": 0, "2": 1, "3": 1, "4": 1, "5": 1, "6": 0 },
      { "1": 0, "2": 1, "3": 1, "4": 0, "5": 0 },
      { "1": 0, "2": 1, "3": 0, "4": 1, "6": 0 },
      { "1": 1, "3": 0, "4": 1, "5": 0, "6": 0 },
      { "1": 1, "3": 0, "4": 1, "5": 1, "6": 1 },
      { "1": 0, "2": 0, "3": 1, "5": 0 },
      { "1": 1, "3": 0, "4": 0, "5": 1 },
    ],
    "9": [{ "1": 0, "2": 1, "3": 1, "4": 1, "5": 0, "6": 0 }],
    "10": [{ "1": 1, "2": 1, "3": 1, "4": 1, "6": 0 }],
  },
};
